<template>
  <div class="and-or-template col-xs-12" :class="isFirst ? 'and-or-first' : ''">
    <div class="form-group and-or-top col-xs-12">
      <div class="btn-and-or">
        <a-tooltip placement="top" v-if="isFirst">
          <template slot="title">
            <span>Add Group</span>
          </template>
          <img class="sbxs" style="margin-left: 4px;" src="../../../../assets/img/ss-add.png"  width="22" height="22" @click="titleClickMenu('0')">
        </a-tooltip>

        <a-tooltip placement="top" v-else>
          <template slot="title">
            <span>Add Field</span>
          </template>
          <img class="sbxs" src="../../../../assets/img/ss-add.png" width="22" height="22" @click="titleClickMenu('1')">
        </a-tooltip>
        <img v-if="!isFirst" class="sbxs" @click.prevent="deleteSelf()" src="../../../../assets/img/ss-delete.png" width="22" height="22" style="margin-left: 4px">
      </div>
    </div>
    <rule
      v-for="(rule, index) in rules"
      ref="rules"
      :options="options"
      :key="rule"
      @delete-rule="deleteRule(index)"
    >
    </rule>

    <and-or
      class="and-or-offset col-xs-11"
      v-for="(group, index) in groups"
      ref="groups"
      :options="options"
      :key="group"
      @delete-group="deleteGroup(index)"
    >
    </and-or>
  </div>
</template>

<script>
import Rule from "./Rule";

export default {
  name: "andOr",
  components: {
    Rule
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.addRule();
  },
  data() {
    return {
      isAnd: true,
      groups: [],
      rules: []
    };
  },
  methods: {
    clickAnd() {
      this.isAnd = true;
    },

    clickOr() {
      this.isAnd = false;
    },

    addRule() {
      var id = this.generateId();
      this.rules.push(id);
    },

    addGroup() {
      var id = this.generateId();
      this.groups.push(id);
    },
    titleClickMenu(val) {
        if (val == "0") {
        this.addGroup();
      } else {
        this.addRule();
      }
    },
    deleteSelf() {
      this.$emit("delete-group");
    },

    deleteRule(index) {
      this.rules.splice(index, 1);
    },

    deleteGroup(index) {
      this.groups.splice(index, 1);
    },

    queryFormStatus() {
      var query = {};
      var rules = this.$refs.rules || {};
      var groups = this.$refs.groups || {};
      var i, j;

      query["condition"] = this.isAnd ? "AND" : "OR";
      query["rules"] = [];
      for (i = 0; i < rules.length; i++) {
        query.rules.push(rules[i].queryFormStatus());
      }
      for (j = 0; j < groups.length; j++) {
        query.rules[query.rules.length] = groups[j].queryFormStatus();
      }
        return query;
    },

    fillFormStatus(data) {
        if(data == undefined){
            data = {condition: "AND", rules: []}
        }
      var i, len;
      var group = this;
      group.rules = [];
      group.groups = [];
      if (data) {
        group.isAnd = /and/i.test(data.condition);
        len = data.rules.length;
        for (i = 0; i < len; i++) {
          if (data.rules[i].condition) {
            group.groups.push(group.generateId());
            (function(i, index) {
              group.$nextTick(function() {
                group.$refs.groups[index].fillFormStatus(data.rules[i]);
              });
            })(i, group.groups.length - 1);
          } else {
            group.rules.push(group.generateId());
            (function(i, index) {
              group.$nextTick(function() {
                group.$refs.rules[index].fillRuleStatus(data.rules[i]);
              });
            })(i, group.rules.length - 1);
          }
        }
      }
    },

    generateId() {
      return "xxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
  }
};
</script>

<style>
.btn-purple-outline-focus {
  background: #6d77b8 !important;
  color: #fff !important;
}
.btnpuClas {
  border: none;
  border-radius: 3px;
  font-size: 14px;
  line-height: 25px;
  color: #000000de;
  background: #efefef;
}
.and-or-template {
  padding: 8px;
  position: relative;
  border-radius: 3px;
  /*border: 1px solid #6d77b8;*/
  /*border-top: 1px solid #d2d6de;*/
  margin-bottom: 4px;
  /* width: 100%; */
  /*border-top-color: #6d77b8;*/
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 6px #d3d3d3;
}
.and-or-template:before,
.and-or-template:after {
  content: "";
  position: absolute;
  left: -17px;
  width: 16px;
  height: calc(50% + 18px);
  border-color: #c0c5e2;
  border-style: solid;
}
.and-or-template:before {
  top: -18px;
  border-width: 0 0 2px 2px;
}
.and-or-template:after {
  top: 50%;
  border-width: 0 0 0 2px;
}
.and-or-first:before,
.and-or-first:after,
.and-or-template:last-child:after {
  border: none;
}
.and-or-top,
.btn-and-or {
  padding: 0;
  float: left;
  margin: 2px 0 0 4px;
}
.btn-and-or button {
  margin-left: 4px;
}
.and-or-offset {
  margin-left: 31px;
}
</style>
